export default __webpack_public_path__ + "static/media/postImage4.ec13b460.png";